<template>
  <div class="con-wrap-inner">
    <el-aside width="280px" style="height:auto">
      <el-row class="title" :gutter="20">
        <el-col :span="16">
          <div class="grid-content bg-purple">部门列表</div>
        </el-col>
        <el-col :span="2" :offset="6">
          <div
            @click="addDept"
            v-if="hasPerm('sys:dept:save')"
            class="grid-content bg-purple iconfont icon-add"
            style="cursor:pointer"
          ></div>
        </el-col>
      </el-row>
      <div>
        <div class="custom-tree-container">
          <div class="block">
            <el-tree
              :data="deptTreeData"
              node-key="id"
              @node-click="clickDept"
              default-expand-all
              highlight-current
              :expand-on-click-node="false"
            >
              <span
                class="custom-tree-node is-show"
                slot-scope="{ node, data }"
              >
                <span>{{ node.label }}</span>
                <span style="display:none">
                  <span
                    @click="editDept(data)"
                    v-if="hasPerm('sys:dept:update')"
                    class="iconfont icon-edit"
                  ></span>
                  <span
                    @click="removeDept(data)"
                    v-if="hasPerm('sys:dept:delete')"
                    class="iconfont icon-delete"
                  ></span>
                </span>
              </span>
            </el-tree>
          </div>
        </div>
      </div>
    </el-aside>

    <el-aside width="280px">
      <el-row class="title" :gutter="20">
        <el-col :span="16">
          <div class="grid-content bg-purple">岗位列表</div>
        </el-col>
        <el-col :span="2" :offset="6">
          <div
            class="grid-content bg-purple iconfont icon-add"
            style="cursor:pointer"
            @click="addPost"
            v-if="hasPerm('sys:post:save')"
          ></div>
        </el-col>
      </el-row>
      <div>
        <ul class="post-list">
          <li
            v-for="item in postList"
            class="is-show post-list-con"
            :class="{ active: flag == item.postId }"
            :key="item.postId"
            @click="getUserList(item)"
          >
            <span class="postName">{{ item.name }}</span>
            <span style="display:none">
              <span
                @click="editPost(item)"
                v-if="hasPerm('sys:post:update')"
                class="iconfont icon-edit"
              ></span>
              <span
                @click="romovePost(item)"
                v-if="hasPerm('sys:post:delete')"
                class="iconfont icon-delete"
              ></span>
            </span>
          </li>
        </ul>
      </div>
    </el-aside>

    <el-container style="flex-direction:column">
      <el-row class="title" :gutter="20">
        <el-col :span="16">
          <div class="grid-content bg-purple">用户列表</div>
        </el-col>
        <el-col :span="6" :offset="2">
          <div
            class="title-edit"
            style="float:right;"
            @click="editUser"
            v-if="hasPerm('sys:user:deptAndPost')"
          >
            <i class="iconfont icon-edit"></i>
            编辑用户
          </div>
        </el-col>
      </el-row>
      <div style="display:block">
        <span v-for="item in UserList" :key="item.userId" class="tag">{{
          item.fullName
        }}</span>
      </div>
    </el-container>
    <!-- 部门弹框 -->
    <el-dialog
      :title="deptTitle"
      :visible.sync="deptVisible"
      class="mini-dialog"
    >
      <el-form
        :rules="deptRules"
        ref="deptForm"
        :model="deptForm"
        size="mini"
        :inline="true"
      >
        <el-form-item v-if="editTag == 0" label="上级部门">
          <el-input v-model="deptForm.pName" placeholder disabled></el-input>
        </el-form-item>
        <el-form-item prop="name" label="部门名称">
          <el-input
            v-model="deptForm.name"
            placeholder="请输入部门名称"
            maxlength="30"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="deptVisible = false">取 消</el-button>
        <el-button type="primary" @click="deptSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 岗位弹框 -->
    <el-dialog
      :title="postTitle"
      :visible.sync="postVisible"
      class="mini-dialog"
    >
      <el-form
        :rules="postRules"
        ref="postForm"
        :model="postForm"
        size="mini"
        :inline="true"
      >
        <el-form-item prop="name" label="岗位名称">
          <el-input
            v-model="postForm.name"
            placeholder="请输入岗位名称"
            maxlength="30"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="postVisible = false">取 消</el-button>
        <el-button type="primary" @click="postSubmit">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 用户弹框 -->
    <el-dialog
      :title="userTitle"
      :visible.sync="userVisible"
      class="transfer-dialog"
    >
      <user-transfer
        leftTitle="已选择用户"
        rightTitle="未选择用户"
        listName="fullName"
        listId="userId"
        :leftList="UserList"
        :rightList="unUserList"
        @clickLeft="addLeft"
        @clickRight="addRight"
      ></user-transfer>
    </el-dialog>
  </div>
</template>

<script>
import UserTransfer from "../../../../components/UserTransfer.vue"
// let id = 1000;
export default {
  name: "OrgDept",
  components: {
    UserTransfer,
  },
  data() {
    return {
      deptTreeData: [],
      defaultProps: {
        value: "id",
        checkStrictly: true,
      },
      postList: [],
      deptVisible: false,
      postVisible: false,
      userVisible: false,
      deptTitle: "",
      postTitle: "",
      userTitle: "",
      deptForm: {
        name: "",
        pName: "",
      },
      postForm: { name: "" },
      deptRules: {
        name: [
          {
            required: true,
            trigger: "change",
            message: "请输入部门名称",
          },
        ],
      },
      postRules: {
        name: [
          {
            required: true,
            trigger: "change",
            message: "请输入岗位名称",
          },
        ],
      },
      editTag: "0",
      pDeptId: "",
      postId: "",
      flag: -1,
      UserList: [],
      unUserList: [],
      postFlag: false,
    }
  },
  created() {
    this.getDeptList()
  },
  watch: {
    // 根据名称筛选部门树
    // deptName (val) {
    //   this.$refs.deptTreeData.filter(val);
    // },
    // 默认点击Tree第一个节点
    deptTreeData(val) {
      if (val) {
        this.$nextTick(() => {
          document.querySelector(".el-tree-node__content").click()
        })
      }
    },
    postList(val) {
      if (val[0]) {
        this.$nextTick(() => {
          document.querySelector(".post-list-con").click()
        })
      }
    },
  },
  methods: {
    async getDeptList() {
      let _this = this
      let { data: res } = await _this.$axios.get("/api/sys/dept/list")
      if (res.code == 1) {
        _this.deptTreeData = res.data
        _this.pDeptId = res.data[0].id
        _this.deptForm.pName = res.data[0].label
      } else {
        _this.$message.warning(res.msg)
      }
    },
    clickDept(deptDatas) {
      let deptId = deptDatas.id
      this.pDeptId = deptDatas.id
      this.deptForm.pName = deptDatas.label
      this.UserList = []
      this.getPostList(deptId)
    },
    async getPostList(deptId) {
      let _this = this
      let parm = {
        deptId: deptId,
      }
      let { data: res } = await _this.$axios.get("/api/sys/post/list", {
        params: parm,
      })
      if (res.code == 1) {
        _this.postList = res.data
        if (res.data.length != 0) {
          _this.postFlag = true
        } else {
          _this.postFlag = false
        }
      } else {
        _this.$message.warning(res.msg)
      }
    },
    async getUserList(data) {
      let _this = this
      _this.flag = data.postId
      _this.postId = data.postId
      _this.pDeptId = data.deptId
      let parm = {
        deptId: data.deptId,
        postId: data.postId,
        range: 1,
      }
      let { data: res } = await _this.$axios.get("/api/sys/user/options", {
        params: parm,
      })
      if (res.code == 1) {
        _this.UserList = res.data
      } else {
        _this.$message.warning(res.msg)
      }
    },
    addDept() {
      this.editTag = "0"
      //清空表单数据
      this.$resetForm(this, "deptForm")
      //设置弹框标题
      this.deptTitle = "新增部门"
      //显示弹框
      this.deptVisible = true
      this.deptForm.name = ""
    },
    editDept(data) {
      this.editTag = "1"
      //清空表单数据
      this.$resetForm(this, "deptForm")
      //设置弹框标题
      this.deptTitle = "修改部门"
      //显示弹框
      this.deptVisible = true
      this.pDeptId = data.id
      console.log(data.label)
      this.deptForm.name = data.label
    },
    deptSubmit() {
      let _this = this
      let parm = {
        id: _this.pDeptId,
        name: _this.deptForm.name,
      }
      let data = []
      _this.$refs.deptForm.validate(async (valid) => {
        if (valid) {
          if (_this.editTag == "0") {
            data = await _this.$axios.post("/api/sys/dept", parm)
          } else {
            data = await _this.$axios.patch("/api/sys/dept", parm)
          }
          let res = data.data
          if (res.code == 1) {
            //信息提示
            _this.$message.success("操作成功")
            //刷新部门树
            _this.getDeptList()
            _this.deptVisible = false
          } else {
            _this.$message.warning(res.msg)
          }
        }
      })
    },
    removeDept(data) {
      let _this = this
      let deptId = data.id
      _this
        .$confirm("确定删除吗？", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          let { data: res } = await _this.$axios.delete(
            "/api/sys/dept/" + deptId
          )
          if (res.code == 1) {
            _this.$message.success("操作成功")
            _this.getDeptList()
          } else {
            _this.$message.warning(res.msg)
          }
        })
    },
    addPost() {
      this.editTag = "0"
      this.$resetForm(this, "postForm")
      this.postTitle = "新增岗位"
      this.postVisible = true
    },
    editPost(item) {
      this.editTag = "1"
      this.$resetForm(this, "postForm")
      this.postTitle = "修改岗位"
      this.postVisible = true
      this.postId = item.postId
      this.postForm.name = item.name
    },
    postSubmit() {
      let _this = this
      let id = 0
      if (_this.editTag == "0") {
        id = _this.pDeptId
      } else {
        id = _this.postId
      }
      let parm = {
        id: id,
        name: _this.postForm.name,
      }
      let data = []
      _this.$refs.postForm.validate(async (valid) => {
        if (valid) {
          if (_this.editTag == "0") {
            data = await _this.$axios.post("/api/sys/post", parm)
          } else {
            data = await _this.$axios.patch("/api/sys/post", parm)
          }
          let res = data.data
          if (res.code == 1) {
            _this.$message.success("操作成功")
            _this.getPostList(_this.pDeptId)
            _this.postVisible = false
          } else {
            _this.$message.warning(res.msg)
          }
        }
      })
    },
    romovePost(item) {
      let _this = this
      let postId = item.postId
      _this
        .$confirm("确定删除吗？", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          let { data: res } = await _this.$axios.delete(
            "/api/sys/post/" + postId
          )
          if (res.code == 1) {
            _this.$message.success("操作成功")
            _this.getPostList(_this.pDeptId)
          } else {
            _this.$message.warning(res.msg)
          }
        })
    },
    editUser() {
      console.log(!this.postFlag)
      if (!this.postFlag) {
        this.$message.warning("请先新增岗位")
        return
      }
      this.userVisible = true
      this.userTitle = "编辑用户"
      this.getUnselectUser()
    },
    async getUnselectUser() {
      let _this = this
      let parm = {
        postId: _this.postId,
        range: 2,
      }
      let { data: res } = await _this.$axios.get("/api/sys/user/options", {
        params: parm,
      })
      if (res.code == 1) {
        _this.unUserList = res.data
      } else {
        _this.$message.warning(res.msg)
      }
    },
    async addRight(selectForm) {
      let parm = {
        deptId: this.pDeptId,
        operating: 2,
        postId: this.postId,
        userIds: selectForm,
      }
      this.reviseUserRely(parm)
    },
    async addLeft(unselectForm) {
      let parm = {
        deptId: this.pDeptId,
        operating: 1,
        postId: this.postId,
        userIds: unselectForm,
      }
      this.reviseUserRely(parm)
    },
    async reviseUserRely(parm) {
      let _this = this
      let { data: res } = await _this.$axios.patch(
        "/api/sys/user/deptAndPost",
        parm
      )
      if (res.code == 1) {
        //信息提示
        _this.$message.success("操作成功")
        //刷新部门树
        _this.getUnselectUser()
        _this.getUserList(parm)
      } else {
        _this.$message.warning(res.msg)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.con-wrap-inner {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  background-color: #f8f8f8;
}
.con-wrap-inner .el-container {
  background-color: #fff;
}
.title-edit {
  cursor: pointer;
}
.title-edit:hover {
  color: #0094ff;
}
.is-show:hover :nth-child(2) {
  display: inline-block !important;
}
.post-list {
  position: relative;
  cursor: default;
  background: #fff;
  color: #606266;
}
.post-list .is-show {
  height: 28px;
  line-height: 28px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding: 0 14px;
  cursor: pointer;
}
.post-list .is-show:hover {
  background: #f5f7fa;
}
.post-list .active {
  background: #ddf0fe !important;
  color: #0094ff;
}
.tag {
  display: inline-block;
  width: 120px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  margin: 10px;
  font-size: 14px;
  color: #333;
  border-radius: 4px;
  background-color: #ddf0fe;
}
</style>
